import { PageHeader as LayoutPageHeader } from '../layout/PageHeader'

export function PageHeader({ minimal = false, ...props }) {
  return <LayoutPageHeader {...props} compact={minimal || props.compact} />
}
